export default __webpack_public_path__ + "static/media/sv11_kr_star_b1.9ccf3bb0.mp3";